import React, { useEffect, useState } from 'react';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import { fetchAnnouncements } from '../components/contentfulFiles';
import '../styles/announcements.css';
import backgroundImage from '../assets/announcement.avif';
import withScroll from '../components/scroll';
import { Helmet } from 'react-helmet';

const PREVIEW_LENGTH = 200;

const formatDateTime = (dateStr, timeStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const isValid = !isNaN(date.getTime());

  const datePart = isValid
    ? date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : dateStr;

  if (timeStr) return `${datePart} at ${timeStr}`;

  if (isValid && (date.getHours() !== 0 || date.getMinutes() !== 0)) {
    const timePart = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    return `${datePart} at ${timePart}`;
  }

  return datePart;
};
const Announcements = ({ sectionRef, handleScroll }) => {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const getAnnouncements = async () => {
      const fetchedAnnouncements = await fetchAnnouncements();
      setAnnouncements(fetchedAnnouncements);
    };
    getAnnouncements();
  }, []);

  const toggleReadMore = (index) => {
    setAnnouncements((prev) =>
      prev.map((ann, i) =>
        i === index ? { ...ann, isExpanded: !ann.isExpanded } : ann
      )
    );
  };

  return (
    <div className="announcements-page">
      <Helmet>
        <title>Announcements - Calvary First Nigerian SDA Church</title>
      </Helmet>
      <Navbar />
      <main>

        {/* ── Hero ── */}
        <section
          className="ann-hero"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="ann-hero-content">
            <h1>
              Stay up to date<br />
              with our latest announcements
            </h1>
          </div>
          <div className="ann-hero-buttons">
            <button className="ann-btn" onClick={handleScroll}>Read More</button>
          </div>
        </section>

        {/* ── Announcements list ── */}
        <section ref={sectionRef} className="announcements-container">
          <h2>Announcements</h2>
          <p className="announcements-sub">
            Stay informed with the latest news from our community
          </p>

          {announcements.length > 0 ? (
            announcements.map((announcement, index) => {
              const fullText   = announcement.fields.text || '';
              const isLong     = fullText.length > PREVIEW_LENGTH;
              const isExpanded = announcement.isExpanded;
              const bodyText   = isLong && !isExpanded
                ? `${fullText.substring(0, PREVIEW_LENGTH)}...`
                : fullText;

              return (
                <div key={index} className="announcement">
                  <div className="announcement-header">
                    <p className="announcement-title">{announcement.fields.title}</p>
                    {announcement.fields.announcedate && (
                      <span className="announcement-date">
                        {formatDateTime(
                          announcement.fields.announcedate,
                          announcement.fields.time  // include if Contentful has a separate time field
                        )}
                      </span>
                    )}
                  </div>
                  <hr className="announcement-divider" />
                  <p className="announcement-body">{bodyText}</p>
                  {isLong && (
                    <button
                      className="announcement-read-more"
                      onClick={() => toggleReadMore(index)}
                    >
                      {isExpanded ? 'Show Less ↑' : 'Read More ↓'}
                    </button>
                  )}
                </div>
              );
            })
          ) : (
            <p className="announcements-empty">No announcements available at the moment.</p>
          )}
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default withScroll(Announcements);